export const PROJECT_FREQUENCY_OPTIONS = [
  'One-time',
  'Daily',
  'Weekly',
  'Fortnightly',
  'Monthly',
  'Custom schedule',
];

/** Map quote / stored labels onto the project frequency dropdown. */
export function matchProjectFrequencyOption(raw) {
  const n = String(raw || '')
    .trim()
    .toLowerCase();
  if (!n) return 'One-time';
  if (n.includes('daily')) return 'Daily';
  if (n.includes('fortnight')) return 'Fortnightly';
  if (/\bweekly\b|every\s*week/.test(n)) return 'Weekly';
  if (/\bmonthly\b|every\s*month/.test(n)) return 'Monthly';
  if (n.includes('custom')) return 'Custom schedule';
  if (/one[\s-]?time|one[\s-]?off|\bonce\b|\bsingle\b/.test(n)) {
    return 'One-time';
  }
  return 'One-time';
}

export function isRecurringFrequencyOption(freq) {
  return isRecurringProjectFrequencyLike(freq);
}

/** Local calendar month as YYYY-MM for “Invoice this month”. */
export function currentBillingPeriod(now = new Date()) {
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
}

function isRecurringProjectFrequencyLike(freq) {
  const n = String(freq || '').trim().toLowerCase();
  if (!n || /one[\s-]?time|one[\s-]?off|\bonce\b|\bsingle\b/.test(n)) {
    return false;
  }
  return (
    ['daily', 'weekly', 'fortnightly', 'monthly', 'quarterly', 'yearly'].includes(
      n,
    ) ||
    /\bdaily\b|\bweekly\b|\bfortnight|\bmonthly\b|\bquarter|\byearly\b|\bbi-?annual|custom/.test(
      n,
    )
  );
}

const FIND_BOOKING_QUOTATION_FREQ = `
  query FindBookingQuotationFrequency($bookingId: String!) {
    findBookingQuotation(bookingId: $bookingId) {
      id
      clientStatus
      quotationStage
    }
  }
`;

const FIND_QUOTATION_VERSION_FREQ = `
  query FindOneQuotationVersionFrequency($id: String!) {
    findOneQuotationVersion(id: $id) {
      id
      rawData
    }
  }
`;

/**
 * Prefill project frequency from the latest quotation on this lead.
 * Does not use booking-service frequencies.
 */
export async function fetchQuoteProjectFrequency(graphqlRequest, bookingId) {
  if (!bookingId) return 'One-time';
  try {
    const listRes = await graphqlRequest(FIND_BOOKING_QUOTATION_FREQ, {
      bookingId,
    });
    const rows = listRes?.findBookingQuotation || [];
    const statusOf = (q) => String(q.clientStatus || '').toUpperCase();
    const stageOf = (q) => String(q.quotationStage || '').toUpperCase();
    const pick =
      rows.find((q) => statusOf(q) === 'ACCEPTED') ||
      rows.find((q) => stageOf(q) === 'SENT' && statusOf(q) !== 'REJECTED') ||
      rows.find((q) => stageOf(q) === 'DRAFT') ||
      rows[0];
    if (!pick?.id) return 'One-time';
    const detail = await graphqlRequest(FIND_QUOTATION_VERSION_FREQ, {
      id: pick.id,
    });
    return matchProjectFrequencyOption(
      detail?.findOneQuotationVersion?.rawData?.workflow?.projectFrequency,
    );
  } catch {
    return 'One-time';
  }
}
